import React from "react";
import { IPwaProps } from "../../interfaces";
import { formatRating, formatReviews } from "../../utils/helpers";
import InstallButton from "../InstallButton/InstallButton";
import Star from "../../assets/icons/Star";
import ImageIcon from "../../assets/icons/ImageIcon";
import "./styles.scss";
import Dot from "../../assets/icons/Dot";
import Arrow from "../../assets/icons/Arrow";
import TitleCheckMark from "../../assets/icons/TitleCheckMark";
// import Search from "../../assets/icons/Search";
import { textsToTranslate } from "../../utils/translationServise";

const MainInfo: React.FC<IPwaProps> = ({
  pwa,
  defferedPrompt,
  setDefferedPrompt,
  testPwaDomain,
  currentGeo,
  ip,
  onInstallCallback,
  xRequestedWith,
}) => {
  const translations = pwa.translations || textsToTranslate;

  return (
    <div className="pb-16">
      <div className="header">
        <div
          className="iconContainer"
          onClick={() => {
            if (pwa?.trafficBack) {
              window.location.href = pwa.trafficBack;
            } else {
              window.history.back();
            }
          }}
        >
          <Arrow width="25px" height="25px" />
        </div>
        <div className="iconContainer">
          {/* <Search /> */}
          <Dot />
        </div>
      </div>
      <div className="wrapper">
        <div className="infoContainer grid-container">
          <div className="infoContainerTopInner item-large">
            <div className="infoContainerInner">
              <div className="iconWrapper">
                {pwa?.creatives?.icon ? (
                  <img src={pwa.creatives.icon} alt="app icon" className="iconImage" />
                ) : (
                  <ImageIcon />
                )}
              </div>

              <div className="textContainer">
                <div className="appnameContainer">
                  <h1 className="appName">{pwa?.appName}</h1>
                  <TitleCheckMark isSecondThemeColor={pwa?.secondPwaTheme} />
                </div>
                <div>
                  <p className={`author ${pwa?.secondPwaTheme ? "authore-second-theme" : ""}`}>{pwa?.author}</p>
                  {pwa.ad && (
                    <div>
                      <p className="adsInfo">
                        {translations?.containsAds}
                        <span>&bull;</span> {translations?.inAppPurchases}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="detailsContainer">
              <div className="detailsItem">
                <div className="ratingContainer">
                  <p className="rating ">
                    {formatRating(pwa?.rating)} <Star width="12px" height="12px" />
                  </p>
                </div>
                <p className="reviews">{`${translations?.reviews}: ${formatReviews(pwa?.amountReviews)}`}</p>
              </div>

              {/* <div className="separator" />*/}

              {/* <div className="detailsItem">*/}
              {/*  <div className="downloadIcon">*/}
              {/*    <DownloadStoreApp />*/}
              {/*  </div>*/}
              {/*  <p className="size">{pwa.size} MB</p>*/}
              {/*</div> */}

              <div className="separator" />

              <div className="detailsItem">
                <p className="downloads">{formatReviews(pwa?.numberOfInst)}</p>
                <p className="downloadsText">{translations?.downloads}</p>
              </div>

              <div className="separator" />

              <div className="detailsItem">
                <span className="ageRating">18+</span>
                <p className="ageRatingText">{translations?.ratedFor} 18+</p>
              </div>
            </div>
            <InstallButton
              defferedPrompt={defferedPrompt}
              setDefferedPrompt={setDefferedPrompt}
              translations={translations!}
              testPwaDomain={testPwaDomain}
              pwaData={pwa}
              currentGeo={currentGeo}
              ip={ip}
              onInstallCallback={onInstallCallback}
              xRequestedWith={xRequestedWith}
            />
          </div>

          <div className="iconImageWeb item-small">
            {pwa?.creatives?.icon ? <img src={pwa?.creatives?.icon} alt="icon" /> : <ImageIcon />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainInfo;
